module.exports = __webpack_public_path__ + "img/icon_map_108_on_011.e350185c.png";